import { Button } from '@/shared/ui/Button'
import { cn, formatAbbr } from '@lair-finance/util'
import { useAccount } from '@lair-finance/wagmi'
import { useResponsive } from '@/features/responsive/hooks/useResponsive.ts'

export function ConnectedButton({ className, onClick }: { className?: string; onClick?: () => void }) {
  const isTablet = useResponsive('tablet')
  const account = useAccount()
  const formattedAddress = account.address ? formatAbbr(account.address, 4) : '...'

  return (
    <Button
      className={cn(
        'text-greyscale-50 bg-greyscale-700 border-greyscale-500 hover:bg-greyscale-500 hover:text-greyscale-50 hover:border-greyscale-500',
        className,
      )}
      size={isTablet ? 'lg' : 'sm'}
      color={'transparent'}
      onClick={onClick}
      as={'div'}
    >
      {formattedAddress}
    </Button>
  )
}
